import { InstanceDataConfig } from "@/types/chart";

// Becasue Chart.js doesn't support axis unit as the way we want, we need to use a custom component to display the axis unit
const ChartAxisUnit = ({
  instanceDataConfig,
}: {
  instanceDataConfig?: InstanceDataConfig[];
}) => {
  if (!instanceDataConfig) return null;

  if (!instanceDataConfig.every((c) => c.unitAxisType === "top")) {
    return null;
  }

  const leftUnit =
    instanceDataConfig.find((c) => c.yAxisID === "y")?.unit || "";

  const rightUnit =
    instanceDataConfig.find((c) => c.yAxisID !== "y")?.unit || "";

  return (
    <div className="flex justify-between absolute top-10 right-0 w-full pl-5 pr-2 text-xs text-gray-500">
      <div>{leftUnit ? `(${leftUnit})` : ""}</div>
      <div>{rightUnit ? `(${rightUnit})` : ""}</div>
    </div>
  );
};

export default ChartAxisUnit;
